module.exports = __webpack_public_path__ + "static/media/buis_beneden.e7ff5965.jpg";